import React from 'react';
import { Button, Icon, Modal } from 'semantic-ui-react';
import Select from 'components/Form/Select';
import { Field, Formik, Form } from 'formik';
import * as Yup from 'yup';
import moment from 'moment';

const schemaValidation = Yup.object().shape({
	folder: Yup.number().required('Champ requis'),
});

const ReopenFolderModal = ({ open, close, submit, folders, user }) => {
	const formatFolderLabel = (folder) => {
		if (folder.labAppointment)
			return `N°${folder.code} - ${moment(folder.labAppointment._date).format(
				process.env.REACT_APP_DATE_DISPLAY_FORMAT
			)} - ${folder.labAppointment.center.name}`;
		else
			return `N°${folder.code} - Tournée du ${moment(
				folder.appointment.round._date
			).format(process.env.REACT_APP_DATE_DISPLAY_FORMAT)}`;
	};

	return (
		<Modal
			size='small'
			open={open}
			closeOnEscape
			closeOnDimmerClick
			onClose={close}
		>
			<Modal.Header>Consulter un dossier</Modal.Header>
			<Formik
				enableReinitialize
				initialValues={{
					folder: '',
					reopen: false,
				}}
				validationSchema={schemaValidation}
				onSubmit={(values) => {
					submit(values.folder, values.reopen);
					close();
				}}
			>
				{({ submitForm, values }) => (
					<>
						<Modal.Content>
							<Form>
								<Field
									component={Select}
									name='folder'
									customlabel='Dossier'
									placeholder='Sélectionner un dossier'
									options={folders.map((folder) => ({
										value: folder.id,
										label: formatFolderLabel(folder),
									}))}
									required
								/>
							</Form>
						</Modal.Content>

						<Modal.Actions>
							<Button
								onClick={(e) => {
									if (e !== undefined) e.preventDefault();
									close();
								}}
							>
								<Icon name='remove' /> Annuler
							</Button>
							{ user && user.session && user.session.rights === 'ADMIN' &&<Button
								color='red'
								onClick={(e) => {
									if (e !== undefined) e.preventDefault();
									values.reopen = true;
									submitForm();
								}}
							>
								<Icon name='edit' /> Ré-ouvrir
							</Button>}
							<Button
								primary
								onClick={(e) => {
									if (e !== undefined) e.preventDefault();
									values.reopen = false;
									submitForm();
								}}
							>
								<Icon name='browser' /> Voir
							</Button>
						</Modal.Actions>
					</>
				)}
			</Formik>
		</Modal>
	);
};

export default ReopenFolderModal;
